import { z } from 'zod';
import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import InputField from '../../core/Input/TextInput/InputField';
import Button from '../../core/Button/Button';

type loginFormProps = {
  onSubmit: (data: any) => Promise<void>;
  isSubmitting: boolean;
  formTitle: string;
  buttonTitle: string;
};

const schema = z.object({
  mobile: z
    .string()
    .trim()
    .regex(/^09\d{9}$/, {
      message: 'شماره موبایل باید با ۰۹ شروع شده و ۱۱ رقم باشد',
    }),
});

const LoginMobileForm: React.FC<loginFormProps> = ({
  onSubmit,
  isSubmitting,
  formTitle,
  buttonTitle,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(schema),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <h1 className="text-center text-xl text-[#3c5caa] font-bold">
        {formTitle}
      </h1>
      <InputField
        containerClassName="text-start py-2 mb-5"
        inputClassName="ltr border-2 text-black"
        label="شماره تماس"
        type="tel"
        placeholder="۰۹..."
        error={
          typeof errors.mobile?.message === 'string'
            ? errors.mobile.message
            : undefined
        }
        {...register('mobile')}
      />
      <Button>{isSubmitting ? 'درحال ارسال...' : buttonTitle}</Button>
    </form>
  );
};

export default LoginMobileForm;
